import React, { useState, Suspense } from 'react'
import { Canvas } from '@react-three/fiber'
import { useContextBridge } from '@react-three/drei'
import * as THREE from 'three'
import { HelmetProvider } from 'react-helmet-async'
import { Perf } from 'r3f-perf'
import { RotateCw, ZoomIn } from 'lucide-react'

import { SceneXyz3D } from './experience/SceneXyz3D.jsx'
import { PresentationNavigation } from './PresentationNavigation'
import
{
  HtmlOverlay,
  ProgressLoader,
  SplashScreen,
  Seo,
  WebCrafterProvider,
  useWebCrafter,
  WebCrafterContext,
  isDebugMode,
} from '@webcrafter/common'

const GL_CONFIG = {
  alpha: false,
  toneMapping: THREE.ACESFilmicToneMapping,
  toneMappingExposure: 1,
}

const SCENE_PATH = 'assets/scene.glb'

const TUTORIAL_STEPS = [
  {
    icon: <RotateCw className="text-blue-400" />,
    title: 'Navigate Slides',
    description: 'Use arrow keys or click next to move between slides.'
  },
  {
    icon: <ZoomIn className="text-purple-400" />,
    title: 'Explore Index',
    description: 'Click items in the sidebar to view slides.'
  }
]

export function Xyz3D()
{
  const isDebugging = isDebugMode

  return (
    <HelmetProvider>
      <WebCrafterProvider isDebugging={isDebugging}>
        <WebCrafterApp />
      </WebCrafterProvider>
    </HelmetProvider>
  )
}

function WebCrafterApp()
{
  const [ showPopup, setShowPopup ] = useState(false)
  const [ popupContent, setPopupContent ] = useState(null)
  const [ xyzAPI, setXyzAPI ] = useState(null)
  const [ thumbnails, setThumbnails ] = useState({})
  const { isLoaded, isDebugging } = useWebCrafter()
  const ContextBridge = useContextBridge(WebCrafterContext)

  return (
    <>
      <div className="absolute inset-0 bg-black">
        <Canvas shadows="soft" gl={GL_CONFIG}>
          <ContextBridge>
            <Suspense fallback={null}>
              <SceneXyz3D
                path={SCENE_PATH}
                setShowPopup={setShowPopup}
                setPopupContent={setPopupContent}
                isDebugging={isDebugging}
                setXyzAPI={setXyzAPI}
                setThumbnails={setThumbnails}
              />
            </Suspense>
            {isDebugging && <Perf />}
          </ContextBridge>
        </Canvas>
      </div>

      {!isLoaded && <ProgressLoader />}

      <HtmlOverlay
        content={popupContent}
        showPopup={showPopup}
        setShowPopup={setShowPopup}
      />

      {isLoaded && (
        <SplashScreen
          tutorial={TUTORIAL_STEPS}
          title="Presentation Viewer"
          body="Explore this presentation in 3D."
          buttonText="Start"
        />
      )}

      {isLoaded && <PresentationNavigation xyzAPI={xyzAPI} thumbnails={thumbnails} />}
      {isLoaded && <Seo />}
    </>
  )
}

export default Xyz3D
